import React, { Component } from 'react';
import FrameComponents from "../FrameComponents"; 
class indexNew extends Component {
  //进入页面调用接口
  componentDidMount() {}
  render() {
    return (
        <FrameComponents name="ImageAltText" />
    );
  }
}

export default indexNew;
